import React, {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { Block } from '@material-ui/icons';
import { parseISO, format } from 'date-fns';
import { isArray } from 'lodash';

import { UnidataTable, Modal } from '~/components';
import { findData, recordFiltering } from '~/store/modules/msgtcaPosto/actions';
import { t } from '~/helpers';
import api from '~/services/api';

import MyForm from './form';
import ClosureComponent from './Closure';

function MsgtcaPosto() {
  const [item, setItem] = useState({ vems_status_str: 'Ativo' });
  const [permission, setPermission] = useState({
    create: false,
    update: false,
  });

  const formRef = useRef(null);

  const redux = useSelector((state) => state.msgtcaPosto);
  const dispatch = useDispatch();

  const optionsTable = useMemo(
    () => [
      { label: 'ativo', value: 'Ativo' },
      { label: 'inativo', value: 'Inativo' },
    ],
    []
  );

  const actionsTable = useMemo(
    () => [
      permission.update
        ? {
            title: 'Finalizar',
            icon: <Block />,
            action: (value) => formRef.current.handleOpenModal({ data: value }),
            color: 'default',
            disabled: item.vems_status_str === 'Inativo',
          }
        : {},
    ],
    [item, permission]
  );

  const header = useMemo(
    () => [
      { id: 'post_desc', label: 'Posto', filter: { type: 'text' } },
      { id: 'vems_msg_full', label: 'Mensagem', filter: { type: 'text' } },
      {
        id: 'vems_datahora_abert',
        label: 'Data Abertura',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      { id: 'vems_nome_solic', label: 'Solicitante Abertura' },
      { id: 'vems_nome_info_fecha', label: 'Solicitante Fechamento' },
      {
        id: 'vems_datahora_fecha',
        label: 'Data Fechamento',
        formatted: (value) =>
          value && format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'vems_status_str',
        label: 'Ativa',
        filter: { type: 'select', options: optionsTable },
      },
    ],
    []
  );

  const handleGetAPIPermissionsUser = useCallback(async () => {
    try {
      const { data } = await api.get(
        'usuario/permissoes/dlgGeralMensagemTCA.swf '
      );

      const crud = data.shift();

      setPermission({
        create: !!crud.iper_inclusao,
        update: !!crud.iper_alteracao,
      });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  useEffect(() => {
    handleGetAPIPermissionsUser();
  }, []);

  return (
    <>
      <UnidataTable
        fixed
        header={header}
        read={recordFiltering}
        find={findData}
        form={MyForm}
        redux={redux}
        actions={actionsTable}
        create={permission.create}
        update={permission.update}
        onRow={(value) => setItem(value)}
        title="Mensagens Posto TCA"
        detach="post_desc"
        keys={['vems_cod_vems']}
        delete={false}
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        title="Mensagens TCA Geral - Finalizar"
        maxWidth="sm"
        ref={formRef}
        component={ClosureComponent}
        onForm={() => dispatch(recordFiltering(redux.params))}
      />
    </>
  );
}

export default MsgtcaPosto;
